var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenmojiFlagSpain(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 4.25H16.75V13.75H1.25V4.25Z",
    fill: "#F1B31C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 8.25V10C5.7496 10.1325 5.6968 10.2594 5.60312 10.3531C5.50943 10.4468 5.38249 10.4996 5.25 10.5H4.25C4.11751 10.4996 3.99057 10.4468 3.89688 10.3531C3.8032 10.2594 3.7504 10.1325 3.75 10V8.25M1.25 4.25H16.75V6.5H1.25V4.25ZM1.25 11.5H16.75V13.75H1.25V11.5Z",
    fill: "#D22F27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 8.25H5.75V9.25H4.75V8.25Z",
    fill: "#F1B31C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 9.625C4.95711 9.625 5.125 9.45711 5.125 9.25C5.125 9.04289 4.95711 8.875 4.75 8.875C4.54289 8.875 4.375 9.04289 4.375 9.25C4.375 9.45711 4.54289 9.625 4.75 9.625Z",
    fill: "#6A462F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.25V10.5M2.75 8.25V10.5M3.75 7.5C4.05813 7.33681 4.40133 7.25101 4.75 7.25C5.09867 7.25101 5.44187 7.33681 5.75 7.5M2.5 10.5H3M6.5 10.5H7M3.75 8.25H5.75V10C5.7496 10.1325 5.6968 10.2594 5.60312 10.3531C5.50943 10.4468 5.38249 10.4996 5.25 10.5H4.25C4.11751 10.4996 3.99057 10.4468 3.89688 10.3531C3.8032 10.2594 3.7504 10.1325 3.75 10V8.25Z",
    stroke: "#6A462F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenmojiFlagSpain);
export default __webpack_public_path__ + "static/media/openmoji_flag-spain.424a1c9521cf5e841f1291fbedd626c9.svg";
export { ForwardRef as ReactComponent };